var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98746 5C7.23296 5 5 7.23296 5 9.98746C5 12.1004 6.31461 13.9067 8.16996 14.6334C8.12632 14.2388 8.08695 13.6319 8.18724 13.2011C8.27783 12.8119 8.77207 10.722 8.77207 10.722C8.77207 10.722 8.62285 10.4233 8.62285 9.98155C8.62285 9.28806 9.02481 8.7703 9.52532 8.7703C9.9508 8.7703 10.1564 9.08979 10.1564 9.47286C10.1564 9.9008 9.88393 10.5406 9.7433 11.1334C9.62581 11.6299 9.99226 12.0347 10.4819 12.0347C11.3684 12.0347 12.0497 11.1 12.0497 9.75081C12.0497 8.55664 11.1916 7.7217 9.96644 7.7217C8.54736 7.7217 7.71439 8.78611 7.71439 9.88615C7.71439 10.3148 7.87949 10.7745 8.08556 11.0243C8.12628 11.0737 8.13227 11.117 8.12012 11.1674C8.08223 11.3249 7.99812 11.6637 7.98162 11.733C7.95982 11.8243 7.90929 11.8437 7.81484 11.7997C7.19187 11.5097 6.80244 10.5991 6.80244 9.86755C6.80244 8.29421 7.94554 6.8494 10.0978 6.8494C11.828 6.8494 13.1726 8.08228 13.1726 9.72992C13.1726 11.4488 12.0888 12.8321 10.5845 12.8321C10.0791 12.8321 9.60398 12.5696 9.44138 12.2595C9.44138 12.2595 9.19127 13.2117 9.13064 13.4451C9.01804 13.8783 8.71411 14.4213 8.51075 14.7526C8.97744 14.897 9.47336 14.975 9.98746 14.975C12.742 14.975 14.975 12.742 14.975 9.98746C14.975 7.23296 12.742 5 9.98746 5",
    fill: "#47494B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialPinterest);
export default __webpack_public_path__ + "static/media/Social_Pinterest.1b4c0ef221ffd6b27c60ae7c825e0c2a.svg";
export { ForwardRef as ReactComponent };